/* unplugin-vue-components disabled */import { render } from "./ActiveDetail.vue?vue&type=template&id=56ff5744&scoped=true"
import script from "./ActiveDetail.vue?vue&type=script&lang=js"
export * from "./ActiveDetail.vue?vue&type=script&lang=js"

import "./ActiveDetail.vue?vue&type=style&index=0&id=56ff5744&lang=less&scoped=true"
import "./ActiveDetail.vue?vue&type=style&index=1&id=56ff5744&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56ff5744"]])

export default __exports__